export default __webpack_public_path__ + "static/Hommey_Brandmark_Black_RGB-ed741ca5d7701c125624b93b439f7050.png";